__turbopack_context__.v({
  "dark": "SimpleLink-module-scss-module__n8kE0G__dark",
  "light": "SimpleLink-module-scss-module__n8kE0G__light",
  "primary": "SimpleLink-module-scss-module__n8kE0G__primary",
  "secondary": "SimpleLink-module-scss-module__n8kE0G__secondary",
  "simpleLink": "SimpleLink-module-scss-module__n8kE0G__simpleLink",
  "sizeMedium": "SimpleLink-module-scss-module__n8kE0G__sizeMedium",
  "sizeSmall": "SimpleLink-module-scss-module__n8kE0G__sizeSmall",
});
